export { default as AvatarCard } from "./AvatarCard";
export type { AvatarCardProps } from "./AvatarCard.types";
